import { createEmptyUser } from "../../features/user/types/user.functions";
import { toString } from "../../utils/type.utils";

import { TWorkOrderResults } from "../reducers/workOrdersReducer";

export function workOrderNormaliseFormData(data: TWorkOrderResults): TWorkOrderResults {
  return {
    ...data,

    adFormat: data.adFormat ?? "",
    adMedium: data.adMedium ?? "",
    adSpecifications: data.adSpecifications ?? "",
    adType: data.adType ?? "",
    additionalAssetsLocation: data.additionalAssetsLocation ?? "",
    additionalCreativeDetails: data.additionalCreativeDetails ?? "",
    areAdditionalAssetsProvided: data.areAdditionalAssetsProvided ?? false,
    areVendorAssetsProvided: data.areVendorAssetsProvided ?? false,
    assetDescription: data.assetDescription ?? "",
    assetDimension: data.assetDimension ?? "",
    assetLanguages: data.assetLanguages ?? [],
    assetRequest: toString(data.assetRequest),
    assetSize: data.assetSize ?? "",
    assetType: data.assetType ?? "",
    brandsIncluded: data.brandsIncluded ?? "",
    campaignTag: data.campaignTag ?? "",
    colour: toString(data.colour),
    communicationsApproach: data.communicationsApproach ?? "",
    contentCreators: data.contentCreators ?? [],
    contentDirection: data.contentDirection ?? "",
    contentName: data.contentName ?? "",
    copyDirection: data.copyDirection ?? "",
    creativeDirection: data.creativeDirection ?? "",
    cta: data.cta ?? "",
    deploymentAt: data.deploymentAt ?? "",
    dueAt: data.dueAt ?? "",
    endAt: data.endAt ?? "",
    englishAssetUnitLinks: data.englishAssetUnitLinks ?? [],
    englishNumberOfScreens: toString(data.englishNumberOfScreens),
    englishNumberOfStores: toString(data.englishNumberOfStores),
    englishQtyPerStore: toString(data.englishQtyPerStore),
    englishRequired: data.englishRequired ?? false,
    fileFormat: data.fileFormat ?? "",
    fileFormatDescription: data.fileFormatDescription ?? "",
    frenchAssetUnitLinks: data.frenchAssetUnitLinks ?? [],
    frenchNumberOfScreens: toString(data.frenchNumberOfScreens),
    frenchNumberOfStores: toString(data.frenchNumberOfStores),
    frenchQtyPerStore: toString(data.frenchQtyPerStore),
    frenchRequired: data.frenchRequired ?? false,
    fromPricing: data.fromPricing ?? "",
    funnel: data.funnel ?? "",
    hasVendorCommitment: data.hasVendorCommitment ?? false,
    isBuyGet: data.isBuyGet ?? false,
    isCreativeReviewRequired: data.isCreativeReviewRequired ?? false,
    isRegional: data.isRegional ?? false,
    isSegmented: data.isSegmented ?? false,
    isSkuListRequired: data.isSkuListRequired ?? false,
    isVendorApprovalRequired: data.isVendorApprovalRequired ?? false,
    legal: data.legal ?? "",
    legalDetails: data.legalDetails ?? "",
    mandatoryCreativeDetails: data.mandatoryCreativeDetails ?? "",
    notesForCreative: data.notesForCreative ?? "",
    notesForEcomm: data.notesForEcomm ?? "",
    objectiveOrPurpose: data.objectiveOrPurpose ?? "",
    offerDetails: data.offerDetails ?? "",
    ownerDetail: data.ownerDetail ?? createEmptyUser(),
    phdBudget: data.phdBudget ?? "",
    polymorphicCtype: toString(data.polymorphicCtype),
    popStoreTypes: data.popStoreTypes ?? [],
    portalOrPrint: data.portalOrPrint ?? "",
    positions: data.positions ?? [],
    positionDescription: data.positionDescription ?? "",
    preHeaderDirection: data.preHeaderDirection ?? "",
    primaryMessage: data.primaryMessage ?? "",
    projectOverview: data.projectOverview ?? "",
    regions: data.regions ?? [],
    reportingMasterCampaignName: data.reportingMasterCampaignName ?? "",
    secondaryMessage: data.secondaryMessage ?? "",
    segments: data.segments ?? "",
    sitePlacement: data.sitePlacement ?? "",
    size: data.size ?? "",
    skuListUploadLocation: data.skuListUploadLocation ?? "",
    startAt: data.startAt ?? "",
    status: data.status ?? "",
    subjectLineDirection: data.subjectLineDirection ?? "",
    theme: data.theme ?? "",
    traffickingDueAt: data.traffickingDueAt ?? "",
    uploadLocation: data.uploadLocation ?? "",
    utmCampaign: data.utmCampaign ?? "",
    utmContent: data.utmContent ?? "",
    utmMedia: data.utmMedia ?? "",
    utmSource: data.utmSource ?? "",
    utmTerm: data.utmTerm ?? "",
    vendorAssetsLocation: data.vendorAssetsLocation ?? "",
    warehouseEta: data.warehouseEta ?? "",
  };
}
